import React, { type FC } from 'react';
import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';
import FreshchatProvider from 'app/lib/freshchat';
import { useFreshchatConfig } from 'app/lib/freshchat/useFreshchatConfig';
import { getUniversalEnv } from 'app/lib/get-universal-env';

import {
  AuthContext, RegContext, useAuthContextValue,
  useRegContextValue,
} from '../../context';
import { SignContent } from '../SignContent';

const FINGERPRINT_PUBLIC_API_KEY = getUniversalEnv('FINGERPRINT_PUBLIC_API_KEY') || '';

export const ModalContent: FC = () => {
  const authContextValue = useAuthContextValue();
  const regContextValue = useRegContextValue();
  const isFingerprint = useFeatureFlag(FeatureFlag.FINGERPRINT);

  if (isFingerprint && !FINGERPRINT_PUBLIC_API_KEY) {
    console.error(`FINGERPRINT_PUBLIC_API_KEY=${FINGERPRINT_PUBLIC_API_KEY} in src/modules/Signing/components/ModalContent/ModalContent.tsx`);
  }

  const freshchatConfig = useFreshchatConfig();

  return (
    <AuthContext.Provider value={authContextValue}>
      <RegContext.Provider value={regContextValue}>
        <FreshchatProvider
            {...freshchatConfig}
            initialUserData={null}>
          {isFingerprint ? (
            <FpjsProvider
            loadOptions={{
              region: 'eu',
              apiKey: FINGERPRINT_PUBLIC_API_KEY,
            }}>
              <SignContent />
            </FpjsProvider>
          ): (
            <SignContent />
          )}
        </FreshchatProvider>
      </RegContext.Provider>
    </AuthContext.Provider>
  );
};
